import { Splide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css/core';
import clsx from 'clsx';
import { node, object, oneOfType, string } from 'prop-types';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';

import 'assets/styles/components/_slider.scss';

const Slider = ({ children, type = 'fade', options = {}, sliderClass = '' }) => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  useEffect(() => {
    // Change the active slide if the start option is provided
    if (options?.start) {
      sliderRef.current.go(options.start);
    }
  }, [options?.start]);

  return (
    <Splide
      ref={sliderRef}
      hasTrack={false}
      options={{ type: type, breakpoints: { 640: { perPage: 1 } }, ...options }}
      className={clsx('relative', sliderClass)}
    >
      <SplideTrack className="h-full">{children}</SplideTrack>

      <div className="splide__arrows">
        <button type="button" className="splide__arrow splide__arrow--prev btn control" title={t('buttons.prev')}>
          <Icon name="angle-left" />
        </button>

        <button type="button" className="splide__arrow splide__arrow--next btn control" title={t('buttons.next')}>
          <Icon name="angle-right" />
        </button>
      </div>
    </Splide>
  );
};

Slider.propTypes = {
  children: node.isRequired,
  type: string.isRequired,
  options: object,
  sliderClass: oneOfType([string, object])
};

export default Slider;
